var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$padFalg == 'other' ? '' : 'ipad ' + _vm.$padFalg,
    _vm.applets,
    _vm.$store.state.gameType == 1 ? 'lzg' : '',
    _vm.$store.state.gameType == 2 ? 'gl' : '',
    _vm.$store.state.gameType == 3 ? 'dqss' : '',
    _vm.$store.state.gameType == 4 ? 'lhlr' : '',
    _vm.$store.state.gameType == 5 ? 'gl rox' : '',
    _vm.$store.state.wxProgram ? 'xcx' : ''
  ],attrs:{"id":"app"}},[(_vm.$store.state.status != 2)?_c('index',{attrs:{"id":"index"}}):_vm._e(),(_vm.$store.state.status == 2)?_c('banned'):_vm._e(),_c('login',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loginShow),expression:"$store.state.loginShow"}],ref:"login"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }